// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://api.redelivery.dev.k8s.redj.ar',
  googleMapsApiKey: 'AIzaSyBt_6wunqJvptr_YWV7nV6vjepLchI-oAU',
  auth: {
    refreshEndpoint: '/api/token/refresh',
    revokeEndpoint: '/api/token/revoke',
    refreshSkewMs: 60 * 1000,
  },
  featureManagement: {
    reDelivery: false,
    coopExpress: true,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
